import React from 'react'
import ProcedureFlow from 'procedures/Flow'

export const makeFlow = function* (employee) {
  if (!employee) {
    return
  }

  const employmentInsuranceJoined = employee.employment_insurance?.joined
  if (employmentInsuranceJoined) {
    yield 'R62'
  }
}

export const Flow = ({location, match}) => <ProcedureFlow {...{makeFlow, location, match}} />
